import { useScrollAnimation, getStaggerProps, animationClasses } from '@/hooks/useScrollAnimation';

const directions = [
  {
    title: '商業理財',
    description: '出版與商業思考、管理、職場及理財知識相關的閱讀內容。',
    icon: 'ri-funds-line',
    accent: 'primary',
  },
  {
    title: '心理學',
    description: '出版與自我理解、情緒、人際互動及大眾心理學相關的閱讀內容。',
    icon: 'ri-psychotherapy-line',
    accent: 'accent',
  },
  {
    title: '以古諷今',
    description: '透過歷史事件、人物與思想，理解當代社會與人文議題。',
    icon: 'ri-history-line',
    accent: 'secondary',
  },
];

export default function TopicExplorationSection() {
  const { ref, isVisible } = useScrollAnimation();

  const accentStyles: Record<string, { iconBg: string; iconBgHover: string; iconColor: string; border: string }> = {
    primary: {
      iconBg: 'bg-primary-50',
      iconBgHover: 'bg-primary-100',
      iconColor: 'text-primary-500',
      border: 'hover:border-primary-300/60',
    },
    accent: {
      iconBg: 'bg-accent-50',
      iconBgHover: 'bg-accent-100',
      iconColor: 'text-accent-500',
      border: 'hover:border-accent-300/60',
    },
    secondary: {
      iconBg: 'bg-secondary-50',
      iconBgHover: 'bg-secondary-100',
      iconColor: 'text-secondary-500',
      border: 'hover:border-secondary-300/60',
    },
  };

  return (
    <section ref={ref} className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">

          {/* Section header */}
          <div className={`text-center mb-10 md:mb-14 ${animationClasses.base} ${isVisible ? animationClasses.visible : animationClasses.hidden}`}>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4 tracking-tight">
              主要出版方向
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
              財經錢線聚焦商業理財、心理學與以古諷今類書籍，透過不同知識視角，整理個人、社會與時代議題，提供具思考價值的出版內容。
            </p>
          </div>

          {/* Direction cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {directions.map((dir, i) => {
              const styles = accentStyles[dir.accent];
              return (
                <div
                  key={dir.title}
                  {...getStaggerProps(isVisible, i, 200)}
                  className={`group p-6 rounded-xl bg-background-100 border border-background-200/70 ${styles.border} transition-all`}
                >
                  <div className={`w-10 h-10 flex items-center justify-center mb-4 rounded-lg ${styles.iconBg} group-hover:${styles.iconBgHover} transition-colors`}>
                    <i className={`${dir.icon} ${styles.iconColor} text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                    {dir.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {dir.description}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Disclaimer */}
          <div className={`mt-10 text-center ${animationClasses.base} ${isVisible ? animationClasses.visible : animationClasses.hidden}`}>
            <p className="text-xs text-foreground-400 leading-relaxed max-w-xl mx-auto">
              出版內容為一般知識閱讀，不構成投資建議、金融操作指引、心理治療、心理諮商或政治顧問服務。
              個別書籍或作者的觀點，不代表財經錢線或崧博出版的官方立場。
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}